module.exports = __webpack_public_path__ + "static/media/jam-night-spring.8e0f4189.jpg";